module.exports = __webpack_public_path__ + "media/LS_painting.b8676d48.mp4";